export default "__VITE_ASSET__Cke9qa7Y__"